var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"vapp"}},[(!_vm.isMobile)?_c('AppBar'):_c('MobileNavigation'),_c('Snackbar'),_c('v-content',{attrs:{"id":"content"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }